
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { BsCalendar } from "react-icons/bs";
import HomeOutlined from "@mui/icons-material/HomeOutlined";
import KeyboardArrowDownOutlined from "@mui/icons-material/KeyboardArrowDownOutlined";
import CalendarTodayOutlined from "@mui/icons-material/CalendarTodayOutlined";
import DownloadOutlined from "@mui/icons-material/DownloadOutlined";
import Dropdown from "react-bootstrap/Dropdown";
import { RiHome6Line } from "react-icons/ri";
import { MdKeyboardArrowRight } from "react-icons/md";
import React, { useState, useRef, useEffect } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { FiDownload, FiChevronDown, FiChevronLeft, FiChevronRight } from "react-icons/fi";
import PayrollOverview from "../../components/Dashboard/payroll-dashboard/PayrollOverview";
import PayrollStats from "../../components/Dashboard/payroll-dashboard/PayrollStats";
import BatchProcessingStatus from "../../components/Dashboard/payroll-dashboard/BatchProcessingStatus";
import TaxDeductionTrend from "../../components/Dashboard/payroll-dashboard/TaxDeductionTrend";

import PayrollPipeline from "../../components/Dashboard/payroll-dashboard/PayrollPipeline";
import AIPayrollAssistant from "../../components/Dashboard/payroll-dashboard/AIPayrollAssistant";
import { Breadcrumb, Col } from "react-bootstrap";
import SalaryDistribution from "../../components/Dashboard/payroll-dashboard/SalaryDistribution";
import { Link } from "react-router-dom";
import BenefitsCard from "../../components/Dashboard/payroll-dashboard/BenefitsCard";

const PayrollDashboardPage = () => {

  const [reportOpen, setReportOpen] = useState(false);

    const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState("Monthly Report");
  const [date, setDate] = useState(new Date());

  
  const ref = useRef();

  const options = [
    "Daily Report",
    "Weekly Report",
    "Monthly Report",
    "Yearly Report",
  ];

  // close on outside click
  useEffect(() => {
    const handler = (e) => {
      if (!ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);
  return (
    <div style={{ padding: "15px", background: "#f8f9fa",  }} className="content ">
      {/* PAGE HEADER */}
      <div className="d-md-flex d-block align-items-center justify-content-between mb-4">
        {/* LEFT */}
     <Col md={4} sm={12}>
                  <div className="my-auto mb-2">
                    <h4 style={{ fontWeight: "600", marginBottom: "5px" }}>Payroll Dashboard</h4>
        
                    <Breadcrumb
                      style={{
                        background: "transparent",
                        padding: 0,
                        margin: 0,
                        fontSize: "14px",
                      }}
                    >
                      <Breadcrumb.Item>
               <Link  to="/" >
               
                        <RiHome6Line
                          className="m text-dark"
                          style={{
                            fontSize: "1.2rem", // increased icon size
                            verticalAlign: "middle",
                                                     }}
                        /></Link>
                      </Breadcrumb.Item>
        
                      <MdKeyboardArrowRight className="mt-1 fs-5" />
        
                      <Breadcrumb.Item
                        linkAs="span"
                        className="text-dark text-decoration-none fs-6"
                      >
                       Dashboard
                      </Breadcrumb.Item>
        
                      <MdKeyboardArrowRight className="mt-1 fs-5" />
        
                      <Breadcrumb.Item active>
                        <span className="text-dark fs-6">Payroll Dashboard</span>
                      </Breadcrumb.Item>
                    </Breadcrumb>
                  </div>
                </Col>

        {/* RIGHT */}
      <div className="d-flex gap-2 flex-wrap align-items-center mt-2">

      {/* REPORT DROPDOWN */}
      <div className="custom-dropdown" ref={ref}>
        <div
          className="dropdown-btn"
          onClick={() => setOpen(!open)}
        >
          <FiDownload />
          <span>{selected}</span>
          <FiChevronDown />
        </div>

        {open && (
          <div className="dropdown-menu-custom">
            {options.map((item) => (
              <div
                key={item}
                className={`dropdown-item ${
                  selected === item ? "active" : ""
                }`}
                onClick={() => {
                  setSelected(item);
                  setOpen(false);
                }}
              >
                {item}
              </div>
            ))}
          </div>
        )}
      </div>

      {/* DATE PICKER */}
<div className="date-wrapper">
  <BsCalendar className="cal-icon" />

  <DatePicker
    selected={date}
    onChange={(d) => setDate(d)}
    dateFormat="MMM yyyy"
    showMonthYearPicker
    className="date-input"
    popperPlacement="bottom-end"
    popperClassName="custom-datepicker"
    renderCustomHeader={({ date, decreaseYear, increaseYear }) => (
      <div className="custom-header">
        <button onClick={decreaseYear}>
          <FiChevronLeft />
        </button>
        <span>{date.getFullYear()}</span>
        <button onClick={increaseYear}>
          <FiChevronRight />
        </button>
      </div>
    )}
  />
</div>
    </div>
      </div>

      {/* PAYROLL STATUS CARD */}
      <div className="card mb-4">
        <div className="card-body d-flex justify-content-between align-items-center flex-wrap">
          <div className="d-flex align-items-center gap-2 gap-xl-4 flex-wrap">
            <div className="d-flex align-items-center">
              <span className="me-2 text-success">●</span>
              Payroll Status:
              <span className="badge bg-success ms-2 mt-1">Processing</span>
            </div>
            |
            <div>
              Cut-off: <span className="fw-semibold">Dec 25, 2024</span>
            </div>
            |
            <div>
              Payment Date: <span className="fw-semibold">Dec 31, 2024</span>
            </div>
          </div>

          <button
            className="btn text-white mt-2 mt-lg-0 ms-1"
            style={{
              backgroundColor: "#fd7e14",
              borderColor: "#fd7e14",
            }}
          >
            Run Payroll
          </button>
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-lg-12 col-xxl-5">
          <PayrollOverview  className="card-gap" />
          <PayrollStats  className="card-gap" />
        </div>

        <div className="col-12 col-lg-12 col-xxl-7">
          <SalaryDistribution  className="card-gap"  />
        </div>
      </div>
      <div className="row mt-4">
        <div className="col-12 col-md-12 col-lg-6 col-xxl-4">
          <BatchProcessingStatus   className="card-gap" />
        </div>

        <div className="col-12 col-md-12 col-lg-6 col-xxl-4">
          <TaxDeductionTrend  className="card-gap" />
        </div>

        <div className="col-12 col-md-12 col-lg-12 col-xxl-4">
          <BenefitsCard  className="card-gap" />
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-12 col-xxl-6">
          <PayrollPipeline  className="card-gap" />
        </div>
        <div className="col-12 col-xxl-6 d-flex">
          <AIPayrollAssistant  className="card-gap" />
        </div>
      </div>
      <style>
        {
          `
          /* Dropdown */
.custom-dropdown {
  position: relative;
}

.dropdown-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid #ddd;
  padding: 8px 14px;
  border-radius: 8px;
  background: #fff;
  cursor: pointer;
  font-weight: 500;
}

.dropdown-menu-custom {
  position: absolute;
  top: 110%;
  left: 0;
  width: 200px;
  background: #fff;
  border-radius: 10px;
  padding: 8px;
  box-shadow: 0 8px 20px rgba(0,0,0,0.08);
  z-index: 1000;
}

.dropdown-item {
  padding: 10px 12px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;

}

.dropdown-item:hover {
  background: #f56d25;
  color: #fff;
}

// .dropdown-item.active {
//   background: #f1f1f1;
//   font-weight: 620;

// }

/* Date Picker Wrapper */
/* POPUP CONTAINER */
.react-datepicker {
  border-radius: 16px;
  padding: 10px;
  border: 1px solid #eee;
}

/* HEADER */
.custom-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 600;
  margin-bottom: 10px;
}

.custom-header button {
  border: none;
  background: #f3f4f6;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

/* 🔥 MONTH GRID FIX */
.react-datepicker__month-wrapper {
  display: grid !important;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  padding: 10px;
}

/* MONTH ITEM */
.react-datepicker__month-text {
  text-align: center;
  padding: 10px 0;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 500;
}

/* HOVER */
.react-datepicker__month-text:hover {
  background: #f3f4f6;
}

/* 🔥 SELECTED MONTH (ORANGE) */
.react-datepicker__month-text--selected,
.react-datepicker__month-text--keyboard-selected {
  background-color: #f97316 !important; /* orange */
  color: #fff !important;
}

/* TODAY (optional subtle highlight) */
.react-datepicker__month-text--today {
  font-weight: 600;
}
  @media(max-width:1024px){
.card-gap{
margin-top:20px;
}
}


.date-wrapper {
  position: relative;
  width: 180px; /* adjust if needed */
}

/* ICON */
.cal-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #6b7280;
  font-size: 16px;
  pointer-events: none;
}

/* INPUT FIELD */
.date-input {
  width: 100%;
  height: 40px;
  padding: 0 12px 0 36px;
  border-radius: 10px;
  border: 1px solid #e5e7eb;
  background: #fff;
  font-size: 14px;
  font-weight: 500;
  color: #111827;
  transition: all 0.2s ease;
}

/* HOVER */
.date-input:hover {
  border-color: #d1d5db;
}

/* FOCUS (🔥 main improvement) */
.date-input:focus {
  outline: none;
  border-color: #f97316; /* orange */
  box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.15);
}

/* OPTIONAL: subtle shadow like modern UI */
.date-wrapper {
  border-radius: 10px;
}

/* MOBILE IMPROVEMENT */
@media (max-width: 576px) {
  .date-wrapper {
    width: 100%;
  }
}
/* Mobile */
@media (max-width: 576px) {
  .dropdown-btn span {
    font-size: 13px;
  }

  .date-input {
    width: 70px;
    font-size: 13px;
  }
}`

        }
      </style>
    </div>
  );
};

export default PayrollDashboardPage;

